/**
 * @desc Yung-审批中回调事件
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: defs.basics.ApprovalRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/onEvent`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
